import { DateTime } from "luxon";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateHelper } from "../../../../Common/DateHelper";

export interface IDestination
{
    Web: string;
    Android: string;
    iOS: string;
}
export enum ApplicationType 
{
    flex = "Flex",
    roamer = "Roamer",
}

export class SignPost extends ODataSelect
{
    ShortcutId = '';
    SignPostType = '';
    Heading = '';
    Application: ApplicationType[] = [];  
    Label = '';
    SubHeading = '';
    KPIType = '';
    ValueURI = '';
    Destination: IDestination = {
        Web: '',
        Android: '',
        iOS: ''
    };
    StartDate = DateHelper.null();
    EndDate = DateHelper.null();
    ActionURI = '';
    Icon = '';
    Image = '';
    MaximumCount = 0;
    BuildingKPI_Limit1 = 0;
    BuildingKPI_Limit2 = 0;
    Limit1 = 0;
    Limit2 = 0;
    BuildingKPI_Text0 = '';
    BuildingKPI_Text1 = '';
    BuildingKPI_Text2 = '';
    BuildingKPI_Value = 0;
    ActionLabel = '';
    BuildingKPI_Order = 0;
    Text0 = '';
    Text1 = '';
    Text2 = '';
    Value = 0
    Node_Id = 0
    IsEnabled = 0
    
    public init(response: any, nodeId: number): SignPost
    {
        super.init(response, nodeId);
        this.StartDate = DateHelper.fromIsoByNode(response.StartDate, nodeId);
        this.EndDate = DateHelper.fromIsoByNode(response.EndDate, nodeId);
        return this;
    }
}